enum Status { Hidden, Live, Upcoming, Archived }

export default Status